import React from "react";
import Link from "next/link";

interface RichTextProps {
  Title: string;
  RegularText: string;
  TextForButton?: string; // Optional
  hrefForButton?: string; // Optional
}

const RichText: React.FC<RichTextProps> = ({
  Title,
  RegularText,
  TextForButton,
  hrefForButton,
}) => {
  return (
    <div className="flex justify-center items-center gap-6 flex-col text-center">
      <h3>{Title}</h3>
      <p
        className="max-w-[1300px] w-full text-left md:text-center"
        dangerouslySetInnerHTML={{ __html: RegularText }}
      />
      {TextForButton && hrefForButton && (
        <Link
          href={hrefForButton}
          className="w-fit flex justify-end items-center gap-2.5 py-2 px-5 rounded-full border border-blue-500 text-blue-500 bg-blue-50 hover:bg-blue-500 hover:text-white transition duration-300"
        >
          {TextForButton}
        </Link>
      )}
    </div>
  );
};

export default RichText;
